import { render, staticRenderFns } from "./wxpublic.vue?vue&type=template&id=ed1f1064&scoped=true"
import script from "./wxpublic.vue?vue&type=script&lang=js"
export * from "./wxpublic.vue?vue&type=script&lang=js"
import style0 from "./wxpublic.vue?vue&type=style&index=0&id=ed1f1064&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1f1064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed1f1064')) {
      api.createRecord('ed1f1064', component.options)
    } else {
      api.reload('ed1f1064', component.options)
    }
    module.hot.accept("./wxpublic.vue?vue&type=template&id=ed1f1064&scoped=true", function () {
      api.rerender('ed1f1064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wx/wxpublic.vue"
export default component.exports